module.exports = __webpack_public_path__ + "img/icon_elimination.7ffa9b6b.svg";